import { render, staticRenderFns } from "./PassChange.vue?vue&type=template&id=e687ac26&scoped=true&"
import script from "./PassChange.vue?vue&type=script&lang=js&"
export * from "./PassChange.vue?vue&type=script&lang=js&"
import style0 from "./PassChange.vue?vue&type=style&index=0&id=e687ac26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e687ac26",
  null
  
)

export default component.exports